export const VTSS_LANG = 'VTSS_LANG'
